(function () {

  'use strict';
  angular
    .module('app', ['ngSanitize', 'ui.router', 'countUpModule', 'constants'])
    // .config(['$translateProvider', translateConfig])
    .run(['$rootScope', '$state', 'LoadService', app]);

  /**
   ** Define the main application module
   */
  function app ($rootScope, $state, LoadService) {

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      LoadService.show();
    });

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
      LoadService.hide();
    });

  }


}());